<template>
  <div class="previewUnAuthBox">
    <div class="box">
      <div class="top">
        <img class="topImg" src="../../assets//viewAuth1.png" alt="" />
        <div class="text">
          <div class="main-text">您没有权限访问此页面!</div>
          <div class="sub-text">您可以联系项目所有者以请求访问权限</div>
        </div>
      </div>
      <img class="bomImg" src="../../assets/viewAuth2.png" alt="" />
    </div>
  </div>
</template>
<script lang="ts" setup></script>
<style lang="scss" scoped>
  .previewUnAuthBox {
    height: 100%;
    background-color: var(--bg-color-primary);
    position: relative;
    .box {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      .top {
        display: flex;
        gap: 35px;
        .text {
          .main-text {
            font-weight: bold;
            font-size: 20px;
            color: #ffffff;
            line-height: 27px;
            margin-top: 15px;
          }
          .sub-text {
            font-size: 14px;
            color: #969aa0;
            line-height: 27px;
            margin-top: 28px;
          }
        }
        .topImg {
          width: 200px;
        }
      }
      .bomImg {
        width: 450px;
        position: relative;
        top: -20px;
      }
    }
  }
</style>
